import { useMutation } from "@tanstack/react-query";
import useNotificationHandler from "hooks/useNotificationHandler";
import api from "service/api";

// Request/Response types
export interface BulkPrefillRequest {
  name: string;
  base64Str: string;
  createMtplOffer?: boolean;
}

export interface BulkPrefillResponse {
  url: string;
  name: string;
}

// API function
export const postVehicleBulkInfo = async (
  data: BulkPrefillRequest
): Promise<BulkPrefillResponse> => {
  const response = await api.post("/vehicles/bulk/info", data);
  return response.data;
};

// React Query hook
export const useVehicleBulkPrefillMutation = () => {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation<BulkPrefillResponse, Error, BulkPrefillRequest>({
    mutationFn: postVehicleBulkInfo,
    onError: (error) => {
      handleAddAxiosErrorNotification(error);
    },
  });
};
